import { api } from './api';

export interface Bundle {
  id: number;
  name: string;
  bundle_price: number;
  description: string;
  products: Product[];
}

export interface Product {
  id: number;
  name: string;
  price: number;
  food_parcel_price: number;
  stock_quantity: number;
}

export interface Bread {
  id: number;
  name: string;
  food_parcel_price: number;
  stock_quantity: number;
}

export interface GroceryItem {
  id: number;
  name: string;
  food_parcel_price: number;
  stock_quantity: number;
}

export interface ParcelItem {
  id: number;
  name: string;
  price: number;
  type: string;
  description: string;
}

export interface AddonProduct {
  id: number;
  name: string;
  add_on_price: number;
  stock_quantity: number;
  category_ids: number[];
  category_names: string[];
}

export interface AvailableProducts {
  bundles: Bundle[];
  breads: Bread[];
  grocery_items: GroceryItem[];
  parcel_items: ParcelItem[];
  addon_products?: AddonProduct[];
}

export interface OrderConfiguration {
  food_parcel_id: number;
  bundle_selections: (number | null)[];
  bread_selection: number | null;
  grocery_selections: (number | null)[];
  parcel_item_selections: Record<number, boolean>;
  addon_product_selections?: Record<number, number>;
}

export interface PriceBreakdown {
  food_parcel: {
    name: string;
    price: number;
  };
  bundles?: {
    total: number;
    count: number;
    items?: Array<{ id: number; name: string; price: number }>;
  };
  bread?: {
    name: string;
    price: number;
  };
  grocery?: {
    total: number;
    items: Array<{
      name: string;
      price: number;
    }>;
  };
  parcel_items?: {
    total: number;
    items: Array<{
      name: string;
      price: number;
    }>;
  };
  addon_products?: {
    total: number;
    items: Array<{
      product_id: number;
      name: string;
      quantity: number;
      unit_price: number;
      line_total: number;
    }>;
  };
}

export interface TotalCalculation {
  total: number;
  breakdown: PriceBreakdown;
}

export const orderConfigurationService = {
  /**
   * Get all available products for order configuration
   */
  async getAvailableProducts(foodParcelId: number): Promise<AvailableProducts> {
    const response = await api.get(`/v1/order-configuration/available-products?food_parcel_id=${foodParcelId}`);
    return response.data.data;
  },

  /**
   * Calculate order total based on selections
   */
  async calculateTotal(configuration: OrderConfiguration): Promise<TotalCalculation> {
    const response = await api.post('/v1/order-configuration/calculate-total', configuration);
    return response.data.data;
  },
}; 